/*
 * @Description: 订单利润管理
 * @Author: 杨志航
 * @Date: 2026-08-12 16:19:26
 */
import React, { useState, useEffect } from 'react'
import api from 'api'
import {
  Table,
  Form,
  Input,
  Button,
  Select,
  Alert,
  Spin,
  DatePicker,
  Drawer,
} from 'antd'
import { allTrim, filterParams, getMethodExport } from '@/utils'
import ChangeLog from '../module/ChangeLog'

const { Column } = Table
const FormItem = Form.Item
const Option = Select.Option
const { MonthPicker, RangePicker } = DatePicker
const dateFormatMonth = 'YYYY-MM'
const dateFormat = 'YYYY-MM-DD'

let pageSize = 10
let currentPage = 1
let searchParams = {
  limit: pageSize, 
  page: currentPage,
}

const Main = props => {
  const { getFieldDecorator, validateFields, resetFields, setFieldsValue, getFieldsValue } = props.form
  const { history } = props
  const [count, setCount] = useState(0)
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false)
  const [spinLoading, setSpinLoading] = useState(false)
  const [logVisible, setLogVisible] = useState(false)
  const [logId, setLogId] = useState('')
  const [companyList, setCompanyList] = useState([])
  const [oldOaCompanyList, setOldOaCompanyList] = useState([])
  const [portIdentifyList, setPortIdentifyList] = useState([])
  const [projectList, setProjectList] = useState([])
  const [productList, setProductList] = useState([])

  useEffect(() => {
    resetParams()
    getSearchData()
    getList()
  }, [])

  const getSearchData = () => {
    Promise.all([
      api.getPortIdentifyList({ limit: global.paramsLimit }),
      api.getSelectCompanyList({ limit: global.paramsLimit }),
      api.getOldOaCompanyList(),
      api.getsysProjectChilds({ pid: 0 })
    ]).then(data => {
      setPortIdentifyList(data[0].list)
      setCompanyList(data[1].list)
      setOldOaCompanyList(data[2])
      setProjectList(data[3])
    })
  }

  const onChangeProject = id => {
    if (id) {
      api.getsysProjectChilds({ pid: id }).then(data => {
        setProductList(data)
      })
    } else {
      setProductList([])
    }
    setFieldsValue({
      productId: undefined,
    })
  }

  const resetParams = () => {
    searchParams = {
      limit: pageSize, 
      page: currentPage,
    }
  }

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 },
    }
  }

  //获取列表
  const getList = () => {
    setLoading(true)
    api.getOrderProfitList(searchParams).then(res => {
      const { list, count } = res
      setList(list)
      setCount(count)
      setLoading(false)
    }).catch(() => { setLoading(false) })
  }

  //重置
  const onReset = () => {
    resetFields()
    currentPage = 1
    resetParams()
    setProductList([])
    getList()
  }

  //提交
  const formSubmit = evt => {
    evt.preventDefault()
    setFieldsValue(allTrim(getFieldsValue()))
    validateFields((err, vals) => {
      if (!err) {
        vals = filterParams(vals)
        if (vals.consumption_year_month) {
          vals.consumption_year_month = vals.consumption_year_month.format(dateFormatMonth)
        }
        if (vals.profit_generate_time && vals.profit_generate_time.length === 2) {
          vals.profit_generate_time_min = vals.profit_generate_time[0].format(dateFormat)
          vals.profit_generate_time_max = vals.profit_generate_time[1].format(dateFormat)
        }
        delete vals.profit_generate_time
        currentPage = 1
        resetParams()
        searchParams = {...searchParams, ...vals}
        getList()
      }
    })
  }
  //点击分页
  const onChangeTable = (pagination, filters, sorter) => {
    searchParams.page = currentPage = pagination.current
    searchParams.limit = pageSize = pagination.pageSize
    getList()
  }

  // 导出
  const exportFile = () => {
    let params = JSON.parse(JSON.stringify(searchParams))
    delete params.limit
    delete params.page
    params.export = 1
    setSpinLoading(true)
    getMethodExport('/fortune/orderProfit/list', params).then(() => {
      setSpinLoading(false)
    }).catch(() => setSpinLoading(false))
  }

  const onChangeLog = id => {
    setLogId(id)
    setLogVisible(true)
  }

  return <>
    <Spin spinning={spinLoading}>
      <div className="search-doc-wrap">
        <Form onSubmit={formSubmit} {...formItemLayout} style={{ paddingTop: '10px' }}>
          <div className="form-box">
            <FormItem label="订单编号">
              {getFieldDecorator('order_number')(<Input placeholder="请输入订单编号" />)}
            </FormItem>
            <FormItem label="客户/代理商名称">
              {getFieldDecorator('client_name')(<Input placeholder="请输入客户/代理商名称" />)}
            </FormItem>
            <FormItem label="客户/代理商ID">
              {getFieldDecorator('client_id')(<Input placeholder="请输入客户/代理商ID" />)}
            </FormItem>
            <FormItem label="消耗年月">
              {getFieldDecorator('consumption_year_month')(<MonthPicker placeholder="请选择月份" style={{ width: '100%' }} />)}
            </FormItem>
            <FormItem label="资金账户">
              {getFieldDecorator('fund_account')(<Select 
                placeholder="请选择"
                allowClear
                showSearch
                optionFilterProp="children"
              >
                {
                  companyList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
                }
              </Select>)}
            </FormItem>
            <FormItem label="易企信提单公司">
              {getFieldDecorator('billing_company')(<Select 
                placeholder="请选择"
                allowClear
                showSearch
                optionFilterProp="children"
              >
                {
                  companyList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
                }
              </Select>)}
            </FormItem>
            <FormItem label="老OA提单公司">
              {getFieldDecorator('old_oa_billing_company')(<Select 
                placeholder="请选择"
                allowClear
                showSearch
                optionFilterProp="children"
              >
                {
                  oldOaCompanyList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
                }
              </Select>)}
            </FormItem>
            <FormItem label="端口识别号">
              {getFieldDecorator('port_identify')(<Select 
                placeholder="请选择"
                allowClear
                showSearch
                optionFilterProp="children"
              >
                {
                  portIdentifyList.map((item, index) => <Option key={index} value={item.portIdentify}>{item.portIdentify}</Option>)
                }
              </Select>)}
            </FormItem>
            <FormItem label="项目">
              {getFieldDecorator('project_id')(<Select
                placeholder="请选择"
                allowClear
                showSearch
                optionFilterProp="children"
                onChange={onChangeProject}
              >
                {
                  projectList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
                }
              </Select>)}
            </FormItem>
            <FormItem label="产品">
              {getFieldDecorator('product_id')(<Select 
                placeholder="请选择"
                allowClear
                showSearch
                optionFilterProp="children"
              >
                {
                  productList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
                }
              </Select>)}
            </FormItem>
            <FormItem label="厂商ID">
              {getFieldDecorator('vendor_id')(<Input placeholder="请输入厂商ID" />)}
            </FormItem>
            <FormItem label="订单利润生成日期">
              {getFieldDecorator('profit_generate_time')(<RangePicker
                placeholder={['开始日期', '结束日期']}
              />)}
            </FormItem>
          </div>
          <FormItem className="btns" label=" " colon={false}>
            <Button type="primary" htmlType="submit">查询</Button>
            <Button onClick={onReset}>重置</Button>
          </FormItem>
        </Form>
      </div>
      <div className="line"></div>
      <div>
        <div className="add-wrap">
          <Button type="primary" onClick={() => history.push('/orderManage/profitManage/first')}>一代返点</Button>
          <Button type="primary" onClick={() => history.push('/orderManage/profitManage/second')} style={{ marginLeft: 15 }}>二代返点</Button>
          <Button type="primary" onClick={() => history.push('/orderManage/profitManage/order')} style={{ marginLeft: 15 }}>订单返点</Button>
          <Button type="primary" onClick={exportFile} style={{ marginLeft: 15 }}>数据导出</Button>
        </div>
        <Alert className="corp-count" message={`总计：${count}条数据`} type="info" showIcon />
        <Table
          size="small"
          dataSource={list}
          rowKey={(record, index) => index}
          loading={loading}
          pagination={{
            pageSize,
            total: count,
            current: currentPage,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: ['10', '50', '100', '500', '1000', '2000']
          }}
          onChange={onChangeTable}
          scroll={{ x: 'max-content' }}
        >
          <Column title="消耗日期" dataIndex="consumption_date" fixed="left" />
          <Column title="消耗年月" dataIndex="consumption_year_month" />
          <Column title="消耗市场价" dataIndex="consumption_amount" />
          <Column title="订单编号" dataIndex="order_number" />
          <Column title="客户/代理商名称" dataIndex="client_name" />     
          <Column title="客户/代理商ID" dataIndex="client_id" />
          <Column title="客户类型" dataIndex="client_type_name" />
          <Column title="资金账户" dataIndex="fund_account_name" />
          <Column 
            title="易企信提单公司" 
            dataIndex="billing_company_name" 
            render={(text, record) => record.faorderId > 0 ? text : ''}
          />
          <Column 
            title="老OA提单公司" 
            dataIndex="old_oa_billing_company_name" 
            render={(text, record) => record.faorderId > 0 ? '' : record.billing_company_name}
          />
          <Column title="市场价" dataIndex="market_price" />
          <Column title="实收" dataIndex="actual_price" />
          <Column title="预计收款" dataIndex="predict_price" />
          <Column title="收款类型" dataIndex="payment_type_name" />
          <Column title="端口识别号" dataIndex="port_identify" />
          <Column title="项目" dataIndex="project_name" />
          <Column title="产品" dataIndex="product_name" />
          <Column title="厂商ID" dataIndex="vendor_id" />
          <Column title="折扣" dataIndex="discount" />
          <Column title="一返" dataIndex="first_rebate" />
          <Column title="二返" dataIndex="second_rebate" />
          <Column title="订单利润" dataIndex="order_profit" />
          <Column title="订单利润生成日期" dataIndex="profit_generate_time" />
          <Column 
            title="分成人与比例" 
            dataIndex="employee_distribution_text2" 
            render={(text, record) => text.map((item, index) => <div key={index}>{item}</div>)}
          />
          <Column title="返点来源" dataIndex="rebate_source_name" />
          <Column title="操作"
            key="set" 
            fixed="right"
            align="center"
            width={80}
            render={(text, record) => (<a onClick={() => onChangeLog(record.id)}>记录</a>)}
          />
        </Table>
      </div>
    </Spin>
    <Drawer
      title="订单利润生成记录"
      width={1000}
      onClose={() => setLogVisible(false)}
      visible={logVisible}
      destroyOnClose={true}
    >
      <ChangeLog id={logId} />
    </Drawer>
  </>
}

export default Form.create()(Main)
